const COMPARATOR_RESULT_VALUE = /^\s*[<>]\s*(\d+(?:\.\d+)?)\s*$/;

/**
 * Numeric value used to place the pointer on the enriched graph.
 * Preserves the historical `Number(result)` behavior for existing values
 * and only parses `<n` / `>n` when `Number()` would be NaN.
 */
export function resolveNumericResultValue(
  value: string | undefined | null,
  numericResult?: number
): number {
  if (
    numericResult !== undefined &&
    numericResult !== null &&
    !Number.isNaN(numericResult)
  ) {
    return numericResult;
  }

  const asNumber = Number(value);
  if (!Number.isNaN(asNumber)) {
    return asNumber;
  }

  if (!value || /[\r\n]/.test(value)) {
    return asNumber;
  }

  const match = value.match(COMPARATOR_RESULT_VALUE);
  return match ? Number(match[1]) : asNumber;
}
